import Lenis from "lenis";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// Single scroll authority for the whole app. Lenis owns scroll position,
// GSAP's ticker drives its raf loop, ScrollTrigger syncs off Lenis's
// 'scroll' event. Framer Motion stays untouched — it never reads or
// writes scroll position, only reacts to discrete UI state.
let lenis = null;
let tickerFn = null;

export function initScroll() {
  if (lenis) return lenis; // never create a second instance

  const prefersReduced = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;

  // Reduced motion: skip Lenis entirely and let native scroll run.
  // ScrollTrigger still works fine off native scroll events with no lenis
  // instance to sync against.
  if (prefersReduced) return null;

  lenis = new Lenis({
    duration: 1.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    smoothWheel: true,
    syncTouch: false, // native scroll physics on touch devices
  });

  lenis.on("scroll", ScrollTrigger.update);

  tickerFn = (time) => {
    lenis.raf(time * 1000);
  };
  gsap.ticker.add(tickerFn);
  gsap.ticker.lagSmoothing(0);

  window.__lenis = lenis;

  return lenis;
}

export function destroyScroll() {
  if (!lenis) return;
  if (tickerFn) gsap.ticker.remove(tickerFn);
  lenis.destroy();
  lenis = null;
  tickerFn = null;
  window.__lenis = null;
}

export function getLenis() {
  return window.__lenis ?? null;
}
